import { createContext } from "react";

export const EmailTemplateContext = createContext();